<template>
  <div class="checklist-inspection-tab">
    <ChecklistInspectionRightPaneTable
      :items="sortedItems"
      :currentBadgeLevel="currentBadgeLevel"
      :currentBadgeId="currentBadgeId"
      :resetFilterToNotYetPassedCount="resetFilterToNotYetPassedCount"
      :hasActiveCheckpoints="hasActiveCheckpoints"
      @onInspect="$emit('onInspect', $event)"
      @issueBadge="$emit('issueBadge', $event)"
      @filterChanged="$emit('filterChanged', $event)"
      @filteredCheckpointIdsChanged="$emit('filteredCheckpointIdsChanged', $event)"
      @onClose="$emit('onClose', $event)"
      @onChatterClick="$emit('onChatterClick', $event)"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ChecklistInspectionRightPaneTable from "@components/ChecklistInspectionRightPaneTable/ChecklistInspectionRightPaneTable.vue";

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  currentBadgeLevel: {
    type: String,
    default: null,
  },
  currentBadgeId: {
    type: [String, Number],
    default: null,
  },
  resetFilterToNotYetPassedCount: {
    type: Number,
    default: 0,
  },
  hasActiveCheckpoints: {
    type: Boolean,
    default: false,
  },
});

const LEVEL_ORDER = ["apprentice", "professional", "coach", "master"];
const sortedItems = computed(() =>
  [...props.items].sort((a, b) => {
    const aIdx = LEVEL_ORDER.indexOf((a.level ?? "").toLowerCase());
    const bIdx = LEVEL_ORDER.indexOf((b.level ?? "").toLowerCase());
    return (aIdx === -1 ? Infinity : aIdx) - (bIdx === -1 ? Infinity : bIdx);
  })
);

const emit = defineEmits(["onInspect", "issueBadge", "filterChanged", "filteredCheckpointIdsChanged", "onClose", "onChatterClick"]);
</script>

<style scoped>
.checklist-inspection-tab {
  width: 100%;
}
</style>
